import React, { useState, useEffect, useMemo, useRef } from 'react';
import { GridResultsScreen } from './Grid/GridResultsScreen';
import {EuiFlexGroup,EuiFlexItem,EuiSpacer,EuiFilterGroup,EuiFilterButton} from '@elastic/eui';
import { Action } from '../../../components/Menus/interface';
import { Menu } from '../../../components/Menus';
import FiltrosMenu from '../../../components/Menus/filtros';
import { BarChartPanelScreen } from './Grafico';

interface Props {
  data: any;
  handleFilter(filtro: any): any;
}

const _tipoVisor = [{label:'Grid',value:'grid'}, {label:'Gráfico',value:'chart'}]

const InformeHorasPorDNSGScreen = (props: Props) => {
  const ref:any = useRef();
  const { data, handleFilter } = props;

  const [filtro, setFiltro] = useState<any>(undefined);
  const [tipoVisor, setTipoVisor] = useState<string>(_tipoVisor[0].value)

  const filtrarDatos = () => {
    handleFilter(filtro)
  }

  const filtroInicial = (filtro:any)=>{
    setFiltro(filtro);
    handleFilter && handleFilter(filtro)
  }

  const onFilterClear = () => { 
    ref.current && ref.current.onFilterClear()
  }

  const onExport = () =>{
    ref && ref.current.onExport();
  }

  useEffect(()=> {
    if(filtro){
      filtrarDatos();
    }
  },[filtro])

  const Actions: Action[] = useMemo(()=>[
    {handle:onFilterClear,text:"Limpiar Filtro",size:"s", isDisabled: false, visible:(tipoVisor === 'grid') ,className: "btnFilterClear"},
    {handle:onExport,text:"Exportar",size:"s", isDisabled:false, visible:(tipoVisor === 'grid')}
  ],[onFilterClear,tipoVisor])

  const getView = useMemo(() => {
    return (
      <>
          <GridResultsScreen
            style={{display: tipoVisor === 'grid' ? 'block' : 'none'}}
            data={data}
            selector={false}
            menu={false}
            ref={ref}
          />
          <BarChartPanelScreen data={data} style={{display: tipoVisor === 'grid' ? 'none' : 'flex'}}/>
      </>
    )
  },[data,tipoVisor])

  return(
    <>
    <EuiFlexGroup alignItems={'center'} justifyContent="spaceBetween" className="filter" wrap>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="s" alignItems="center" justifyContent="flexStart" >
          <FiltrosMenu filtroInicial = {filtroInicial} onChangeFilter={setFiltro}/>
          <EuiFlexGroup gutterSize="l" alignItems="center" justifyContent="center" >
            <EuiFlexItem>
                <EuiFilterGroup fullWidth>
                  <EuiFilterButton
                    size='s'
                    hasActiveFilters={tipoVisor===_tipoVisor[0].value}
                    onClick={()=>setTipoVisor(_tipoVisor[0].value)}>
                    {_tipoVisor[0].label}
                  </EuiFilterButton>
                  <EuiFilterButton
                  size='s'
                    hasActiveFilters={tipoVisor===_tipoVisor[1].value}
                    onClick={()=>setTipoVisor(_tipoVisor[1].value)}>
                      {_tipoVisor[1].label}
                  </EuiFilterButton>
                </EuiFilterGroup>
            </EuiFlexItem>
          </EuiFlexGroup>
          <Menu actions={Actions} className="actions"/>
        </EuiFlexGroup>
      </EuiFlexItem>
    </EuiFlexGroup>
     <EuiSpacer size="m" />
     {getView}
   </> 
  );
};

export default InformeHorasPorDNSGScreen;
